import React from "react";
import { Dialog, DialogTitle, DialogContent, Grid, Typography, DialogActions } from "@material-ui/core";
import { CustomButton } from "../..";

const ConfirmationDialog = ({ handleClose, handleConfirm, data, maxWidth, fullWidth }) => {
   return (
      <Dialog
         fullWidth={fullWidth}
         open={true}
         maxWidth={maxWidth}
         onClose={() => handleClose(false)}
         aria-labelledby="max-width-dialog-title"
      >
         {(data || {}).title ? (
            <DialogTitle id="max-width-dialog-title">
               <Grid container justify="center" alignItems="center">
                  <Grid item xs={12}>
                     <Typography variant="subtitle1">{(data || {}).title}</Typography>
                  </Grid>
               </Grid>
            </DialogTitle>
         ) : null}

         <DialogContent style={{ padding: 20 }}>{(data || {}).content}</DialogContent>
         <DialogActions>
            <CustomButton variant="text" className="text-disabled-button" label={"Cancel"} handleChange={handleClose} />
            <CustomButton variant="contained" color="primary" label={"Confirm"} handleChange={handleConfirm} />
         </DialogActions>
      </Dialog>
   );
};

export default ConfirmationDialog;